import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiX } from 'react-icons/fi';

const FTLDispatchModal = ({
  show,
  onClose,
  formData,
  handleInputChange,
  handleSubmit,
  addIntermediateDestination,
  removeIntermediateDestination,
  isLoading,
}) => {
  const { t } = useTranslation();

  if (!show) return null;

  const dispatchMode = formData.ftl.dispatchMode;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-20 flex items-center justify-center p-4">
      <div
        className="rounded-xl shadow-xl text-white p-6 relative w-full max-w-md max-h-[90vh] overflow-y-auto hide-scrollbar"
        style={{ background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)' }}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-2xl font-bold hover:text-gray-300"
          aria-label={t('alt.closeFTLModal')}
        >
          <FiX />
        </button>

        <h2 className="text-xl font-bold mb-4">{t('orders.createFTLDispatch')}</h2>

        <form onSubmit={(e) => handleSubmit(e, 'FTL')} className="space-y-4">
          {/* Dispatch Mode */}
          <div>
            <label className="text-sm block mb-1">{t('orders.dispatchMode')}</label>
            <select name="dispatchMode" value={dispatchMode}
              onChange={(e) => handleInputChange(e, null, 'FTL')}
              className="w-full px-3 py-2 rounded bg-white text-black">
              <option value="">{t('orders.selectDispatchModePlaceholder')}</option>
              <option value="Pick-up Load">{t('orders.pickUpLoad')}</option>
              <option value="Delivery">{t('orders.delivery')}</option>
            </select>
          </div>

          {/* Shipping Method */}
          <div>
            <label className="text-sm block mb-1">{t('orders.shippingMethod')}</label>
            <input type="text" name="shippingMethod1" value={formData.ftl.shippingMethod1}
              onChange={(e) => handleInputChange(e, null, 'FTL')}
              placeholder={t('orders.shippingMethodPlaceholder')}
              className="w-full px-3 py-2 rounded bg-white text-black" />
          </div>

          {/* Pick Empty */}
          <div>
            <label className="text-sm block mb-1">{t('orders.pickEmpty')}</label>
            <input type="text" name="pickEmpty" value={formData.ftl.pickEmpty}
              onChange={(e) => handleInputChange(e, null, 'FTL')}
              placeholder={t('orders.pickEmptyPlaceholder')}
              className="w-full px-3 py-2 rounded bg-white text-black" />
          </div>

          {/* Seal Number */}
          <div>
            <label className="text-sm block mb-1">{t('orders.sealNumber')}</label>
            <input type="text" name="sealNumber" value={formData.ftl.sealNumber}
              onChange={(e) => handleInputChange(e, null, 'FTL')}
              placeholder={t('orders.sealNumber')}
              className="w-full px-3 py-2 rounded bg-white text-black" />
          </div>

          {/* Load Time */}
          <div>
            <label className="text-sm block mb-1">
              {dispatchMode === 'Delivery' ? t('orders.deliveryTime')
                : dispatchMode === 'Pick-up Load' ? t('orders.pickupTime')
                : t('orders.loadTime')}
            </label>
            <input type="time" name="loadTime" value={formData.ftl.loadTime}
              onChange={(e) => handleInputChange(e, null, 'FTL')}
              className="w-full px-3 py-2 rounded bg-white text-black" />
          </div>

          {/* Load Address */}
          <div>
            <label className="text-sm block mb-1">
              {dispatchMode === 'Delivery' ? t('orders.deliveryAddress')
                : dispatchMode === 'Pick-up' ? t('orders.pickupAddress')
                : t('orders.loadAddress')}
            </label>
            <input type="text" name="loadAddress" value={formData.ftl.loadAddress}
              onChange={(e) => handleInputChange(e, null, 'FTL')}
              placeholder={
                dispatchMode === 'Delivery' ? t('orders.deliveryAddressPlaceholder')
                  : dispatchMode === 'Pick-up' ? t('orders.pickupAddressPlaceholder')
                  : t('orders.loadAddressPlaceholder')
              }
              className="w-full px-3 py-2 rounded bg-white text-black" />
          </div>

          {/* Destination */}
          <div>
            <label className="text-sm block mb-1">{t('orders.destination')}</label>
            <input type="text" name="destination" value={formData.ftl.destination}
              onChange={(e) => handleInputChange(e, null, 'FTL')}
              placeholder={t('orders.destinationPlaceholder')}
              className="w-full px-3 py-2 rounded bg-white text-black" />
          </div>

          {/* Commodity */}
          <div>
            <label className="text-sm block mb-1">{t('orders.commodity')}</label>
            <input type="text" name="commodity" value={formData.ftl.commodity}
              onChange={(e) => handleInputChange(e, null, 'FTL')}
              placeholder={t('orders.commodityPlaceholder')}
              className="w-full px-3 py-2 rounded bg-white text-black" />
          </div>

          {/* Return Full */}
          <div>
            <label className="text-sm block mb-1">{t('orders.returnFull')}</label>
            <input type="text" name="returnFull" value={formData.ftl.returnFull}
              onChange={(e) => handleInputChange(e, null, 'FTL')}
              placeholder={t('orders.returnFullPlaceholder')}
              className="w-full px-3 py-2 rounded bg-white text-black" />
          </div>

          {/* Trailer Number */}
          <div>
            <label className="text-sm block mb-1">{t('orders.trailerNumber')}</label>
            <input type="text" name="trailerNumber" value={formData.ftl.trailerNumber}
              onChange={(e) => handleInputChange(e, null, 'FTL')}
              placeholder={t('orders.trailerNumberPlaceholder')}
              className="w-full px-3 py-2 rounded bg-white text-black" />
          </div>

          {/* Booking Number */}
          <div>
            <label className="text-sm block mb-1">{t('orders.bookingNumber')}</label>
            <input type="text" name="bookingNumber" value={formData.ftl.bookingNumber}
              onChange={(e) => handleInputChange(e, null, 'FTL')}
              placeholder={t('orders.bookingNumberPlaceholder')}
              className="w-full px-3 py-2 rounded bg-white text-black" />
          </div>

          {/* Flat Beds */}
          <div>
            <label className="text-sm block mb-1">{t('orders.flatBeds')}</label>
            <input type="text" name="flatBeds" value={formData.ftl.flatBeds}
              onChange={(e) => handleInputChange(e, null, 'FTL')}
              placeholder={t('orders.flatBedsPlaceholder')}
              className="w-full px-3 py-2 rounded bg-white text-black" />
          </div>

          {/* Intermediate Stops */}
          <div>
            <label className="text-sm block mb-1">{t('orders.intermediateStops')}</label>
            {formData.ftl.intermediateDestinations.map((stop, index) => (
              <div key={index} className="flex gap-2 mb-2">
                <input type="text"
                  name={`intermediateDestinations.${index}.destination`}
                  value={stop.destination}
                  onChange={(e) => handleInputChange(e, index, 'FTL')}
                  placeholder={t('orders.stopDestinationPlaceholder', { index: index + 1 })}
                  className="w-full px-3 py-2 rounded bg-white text-black" />
                <input type="time"
                  name={`intermediateDestinations.${index}.time`}
                  value={stop.time}
                  onChange={(e) => handleInputChange(e, index, 'FTL')}
                  className="w-full px-3 py-2 rounded bg-white text-black" />
                <select
                  name={`intermediateDestinations.${index}.stopType`}
                  value={stop.stopType}
                  onChange={(e) => handleInputChange(e, index, 'FTL')}
                  className="w-full px-3 py-2 rounded bg-white text-black">
                  <option value="">{t('orders.selectStopType')}</option>
                  <option value="Pick-up Load">{t('orders.pickUpLoad')}</option>
                  <option value="Delivery">{t('orders.delivery')}</option>
                </select>
                {formData.ftl.intermediateDestinations.length > 1 && (
                  <button type="button" onClick={() => removeIntermediateDestination(index, 'FTL')}
                    className="text-red-400 hover:text-red-600">
                    {t('orders.removeStop')}
                  </button>
                )}
              </div>
            ))}
            {formData.ftl.intermediateDestinations.length < 15 && (
              <button type="button" onClick={() => addIntermediateDestination('FTL')}
                className="text-blue-400 hover:text-blue-600 mt-2">
                {t('orders.addStop')}
              </button>
            )}
          </div>

          <button type="submit"
            className="w-full bg-[#792aff] text-white py-2 rounded-md font-semibold"
            disabled={isLoading}>
            {isLoading ? t('dashboard.loading') : t('orders.createFTLDispatch')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default FTLDispatchModal;